// MUI twin of design/ui.tsx PageHeader. Page heading block: title + optional
// eyebrow (date/context line) + right-aligned actions. Prop API matches the kt
// original verbatim so page ports are a mechanical import swap.
import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { brainTokens } from "../design/brainTheme";

const c = brainTokens.color;

export function PageHeader({
  title,
  eyebrow,
  actions,
}: {
  title: string;
  eyebrow?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px" }}>
      <Box>
        <Box sx={{ fontSize: 24, fontWeight: 600, lineHeight: 1.3, color: c.ink }}>{title}</Box>
        {eyebrow && <Box sx={{ fontSize: 13, color: c.muted, mt: "2px" }}>{eyebrow}</Box>}
      </Box>
      {actions && <Box sx={{ display: "flex", gap: "8px", flexShrink: 0 }}>{actions}</Box>}
    </Box>
  );
}
